import { Row } from "antd";
import classes from "../Pages.module.css";
import DataField from "./DataField";
import { useState } from "react";  
const BasicDetails = (props) => {
  console.log(props,"props in details part");
  const [passwordError, setPasswordError] = useState("");
  const [passwordMismatch, setPasswordMismatch] = useState(false);  // To track if passwords match or not

  console.log(props,"props in details part");
  const handleChange = (value, param) => {
    // console.log(value, param);
    props.setData((data) => {
      const newdata = [...data["itemTax"]];
      newdata[0][param] = value;
      //  // console.log(newdata);
      return {
        ...data,
        itemTax: newdata,
      };
    });
  };


  const handleChangeP = (e, param, id) => {
    const value = e.target.value;
  
    props.setData((data) => {
      const newdata = [...data["itemTax"]];
      newdata[0][param] = value;
  
      // Check password mismatch only when editing "Re-Type Password"
      if (param === "item_code_retype") {
        const password = newdata[0]["item_code"];
        const retypePassword = newdata[0]["item_code_retype"];
  
        if (password !== retypePassword) {
          setPasswordError("Passwords do not match");
          setPasswordMismatch(true);
        } else {
          setPasswordError("");
          setPasswordMismatch(false); // Clear error if passwords match
        }
      }
  
      return {
        ...data,
        itemTax: newdata,
      };
    });
  };
  
  
  
  const handleSChange = (val, param) => {
    props.setData((data) => {
      const newdata = [...data["itemTax"]];

      newdata[0][param] = val;
      return {
        ...data,
        itemTax: newdata,
      };
    });
  };
  // const handleDChange = (date, dateString, param) => {
  //   props.setData((data) => {
  //     const newdata = [...data["itemTax"]];
  //     newdata[0][param] = dateString;
  //     return {
  //       ...data,
  //       itemTax: newdata,
  //     };
  //   });
  // };

  return (
    <div>
      <p></p>
      <Row className={props.editMode ? classes["RowDEX"] : classes["RowD"]}>
        {!props.create && (
          <DataField
            editMode={props.editMode}
            lg={12}
            md={24}
            handleChange={handleChange}
            name="TAX CODE"
            param="tax_code"
            value={props.data.tax_code}
          />
        )}
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleSChange}
          options={props.ad.employee}
          type="Select"
          name="Login Name"
          param="spec_code"
          required="true"
          value={props.data.spec_code}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChangeP}
          name="Password"
          // type="Date"
          param="item_code"
          id="item_code"
          required="true"
          value={props.data.item_code}
          // error={passwordMismatch} // Pass error flag
          // help={passwordMismatch ? passwordError : ""} // Pass error message
        />
       <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChangeP}
          name="Re-Type Password"
          // type="Date"
          param="item_code_retype"
          required="true"
          id="item_code_retype"
          value={props.data.item_code_retype}
          error={passwordMismatch} // Pass error flag
          help={passwordMismatch ? passwordError : ""} // Pass error message
        />
         <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          name="Expiry Days"
          // type="Date"
          param="expiry_days"
          required="true"
          value={props.data.expiry_days}
        />
         <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleSChange}
          options={props.ad.role}
          type="Select"
          name="Role"
          param="role_cd"
          required="true"
          value={props.data.role_cd}
        />

         {/* <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleSChange}
          options={props.ad.company}
          type="Select"
          name="Company"
          param="company_code"
          required="true"
          value={props.data.company_code}
        /> */}
      </Row>
    </div>
  );
};

export default BasicDetails;
